import React, { forwardRef, useImperativeHandle } from 'react';
import useLazy from '@/hooks/useLazy';
import dynamic from 'next/dynamic';

const Content = dynamic(() => import('./content'), { ssr: false });

const PantryPopup = forwardRef((props: any, ref) => {
  const { show, hide, visible, loaded } = useLazy();

  useImperativeHandle(ref, () => {
    return {
      show,
      hide
    };
  });

  return <>{loaded && <Content {...props} visible={visible} onCancel={hide} />}</>;
});

export default PantryPopup;
